module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_furniture_0151eee7d62d3211152e5cd5fae8dbe9.png";